import { actionCreator, ActionReturnType, Loading, loadingNotStarted, loadingIsLoading, loadingFinished, loadingFailed } from "@itk/typescript-utils";
import { Model_RalColorGet } from "src/backend/openapi/v1";

export enum Action {
  GetRalColorsRequest = "@@ITK:SRC:COMPONENTS:RAL-COLORS:RAL-COLORS-STORE.TS:ACTION:GETRALCOLORSREQUEST",
  GetRalColorsSuccess = "@@ITK:SRC:COMPONENTS:RAL-COLORS:RAL-COLORS-STORE.TS:ACTION:GETRALCOLORSSUCCESS",
  GetRalColorsFailure = "@@ITK:SRC:COMPONENTS:RAL-COLORS:RAL-COLORS-STORE.TS:ACTION:GETRALCOLORSFAILURE"
}

type RalColorsState = {
  // shared by every RalColorPicker instance on the page
  ralColors: Loading<Model_RalColorGet[]>;
};

const initialState: RalColorsState = {
  ralColors: loadingNotStarted
};

export const ralColorActions = {
  getRalColorsRequest: () => actionCreator(Action.GetRalColorsRequest),
  getRalColorsSuccess: (data: Model_RalColorGet[]) => actionCreator(Action.GetRalColorsSuccess, { data }),
  getRalColorsFailure: () => actionCreator(Action.GetRalColorsFailure)
};

export const ralColorsReducer = (state = initialState, action: ActionReturnType<typeof ralColorActions>): RalColorsState => {
  switch (action.type) {
    case Action.GetRalColorsRequest:
      return { ...state, ralColors: loadingIsLoading };
    case Action.GetRalColorsSuccess:
      return { ...state, ralColors: loadingFinished(action.payload.data) };
    case Action.GetRalColorsFailure:
      return { ...state, ralColors: loadingFailed };
    default:
      return state;
  }
};
